import { Snowflake, Sun, Leaf, type LucideIcon } from 'lucide-react'
import type { CitySeason } from '@/data/city-seo/card-view'

// Season accent palette, carried as inline-style values (not Tailwind classes)
// so the hub needs zero new @utility/@theme rules. Values mirror the prototype's
// [data-season] tokens: cool = blue, warm = amber, transition = brand green.
export interface SeasonAccent {
  accent: string
  accent700: string
  bg: string
  glow: string
  Icon: LucideIcon
}

export const SEASON: Record<CitySeason, SeasonAccent> = {
  cool: {
    accent: '#3b7fb0',
    accent700: '#2c6690',
    bg: 'rgba(214,231,243,0.66)',
    glow: 'rgba(59,127,176,0.18)',
    Icon: Snowflake,
  },
  warm: {
    accent: '#c2691f',
    accent700: '#9a4f12',
    bg: 'rgba(253,230,196,0.66)',
    glow: 'rgba(217,119,6,0.20)',
    Icon: Sun,
  },
  transition: {
    accent: '#16a34a',
    accent700: '#15803d',
    bg: 'rgba(205,238,214,0.66)',
    glow: 'rgba(22,163,74,0.18)',
    Icon: Leaf,
  },
}
